<template>
  <v-layout align-center justify-center row fill-height>
    <v-flex xs6>

      <v-card v-if="currentSharing">
        <v-card-title primary-title>
          <div>
            <h3 class="headline mb-0">{{ $vuetify.t("$vuetify.CurrentSharing.title") }}</h3>
          </div>
        </v-card-title>


        <v-list dense>

          <v-list-tile>
            <v-list-tile-content>{{ $vuetify.t("$vuetify.CurrentSharing.takeAt") }}:</v-list-tile-content>
            <v-list-tile-content class="align-end">{{ currentSharing.takeAt | moment("DD/MM/YYYY HH:mm") }}
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile v-if="currentSharing.startBay">
            <v-list-tile-content>{{ $vuetify.t("$vuetify.CurrentSharing.startBay") }}:</v-list-tile-content>
            <v-list-tile-content class="align-end">{{ currentSharing.startBay.label }}</v-list-tile-content>
          </v-list-tile>
          <v-list-tile>
            <v-list-tile-content>{{ $vuetify.t("$vuetify.CurrentSharing.duration") }}:</v-list-tile-content>
            <v-list-tile-content class="align-end">{{ [currentSharing.duration, 'seconds'] | duration('humanize') }}
            </v-list-tile-content>
          </v-list-tile>


        </v-list>

        <v-btn v-if="vehicle.bikeLock" @click="makeUnlock()" color="button-light" block>
          {{ $vuetify.t("$vuetify.CurrentSharing.bike_lock.button") }}
        </v-btn>
        <v-alert
            :value="bike_unlock_success"
            type="success"
            transition="scale-transition"
        >
          {{ $vuetify.t("$vuetify.CurrentSharing.bike_lock.success_message") }}
        </v-alert>
        <v-alert
            :value="bike_unlock_failure"
            type="warning"
            transition="scale-transition"
        >
          {{ $vuetify.t("$vuetify.CurrentSharing.bike_lock.failure_message") }}
        </v-alert>
      </v-card>


    </v-flex>
  </v-layout>

</template>


<script>
import UNLOCK_MUTATION from "@/graphql/mutations/bikeLockUnlock.gql";

export default {
  name: "CurrentSharing",
  apollo: {
    user: {
      client: "clientPrivate",
      query: require("../graphql/queries/currentUserFull.gql"),
      update({user: {currentSharing}}) {
        this.currentSharing = currentSharing;
        this.vehicle = currentSharing.vehicle;
      }
    }
  },
  data: function () {

    return {
      currentSharing: null,
      vehicle: null,
      bike_unlock_success: false,
      bike_unlock_failure: false
    }
  },
  methods: {
    makeUnlock() {

      this.$apollo.mutate({
        client: "clientPrivate",
        // Query
        mutation: UNLOCK_MUTATION,
        // Parameters
        variables: {
          vehicle_id: this.vehicle.id,
        },

      }).then(({data: {bikeLockUnlock: {result}}}) => {

        if (result) {
          this.bike_unlock_success = true
        } else {
          this.bike_unlock_failure = true
        }
        setTimeout(() => {
          this.bike_unlock_success = false
          this.bike_unlock_failure = false
        }, 1500)


      }).catch((error) => {
        console.log(error)

        //TODO implementare default error catcher
        // Error
        //console.error(error)

      })


    }
  }
}
</script>
